import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { AuthenticationService } from 'app/auth/service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private authService: AuthenticationService) {}

  // canActivate
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let can = false;
    await this.authService.checkAuth().then((x) => (can = x));
    if (!can) {
      localStorage.setItem('routeBeforeLogin',state.url);
      this._router.navigateByUrl('/pages/login');
    }
    return can;
  }
}
